import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";

export const getMinaPendingOrderReport = createAsyncThunk(
  "Mina/FindAllMinaPendingOrder",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Mina/FindAllMinaPendingOrder`,
        formdata,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Mina Pending Order Report:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const getDullPendingOrderReport = createAsyncThunk(
  "Dull/FindAllDullPendingOrder",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dull/FindAllDullPendingOrder`,
        formdata,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Dull Pending Order Report:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const getPalishPendingOrderReport = createAsyncThunk(
  "Palish/FindAllPalishPendingOrder",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Palish/FindAllPalishPendingOrder`,
        formdata,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Dull Pending Order Report:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const getGhatPendingOrderReport = createAsyncThunk(
  "GhatReceipt/FindALLGhatReceiptPendingOrder",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/GhatReceipt/FindALLGhatReceiptPendingOrder`,
        formdata,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Ghat Pending Order Report:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const getBandhaiPendingOrderReport = createAsyncThunk(
  "Bandhai/FindALLBandhaiReceiptPendingOrder",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Bandhai/FindALLBandhaiReceiptPendingOrder`,
        formdata,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Bandhai Pending Order Report:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const getJadaiPendingOrderReport = createAsyncThunk(
  "Jadai/FindALLJadaiReceiptPendingOrder",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Jadai/FindALLJadaiReceiptPendingOrder`,
        formdata,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Jadai Pending Order Report:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const getKarigarPhineLedgerReport = createAsyncThunk(
  "Karigar/KarigarWisePhineSummaryReport",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Karigar/KarigarWisePhineSummaryReport`,
        formdata,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Jadai Pending Order Report:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getKarigarAmountLedgerReport = createAsyncThunk(
  "Karigar/KarigarWiseAmountSummaryReport",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Karigar/KarigarWiseAmountSummaryReport`,
        formdata,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Karigar Amount Ledger Report:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getKarigarWiseGhatAmountPhineSummaryReport = createAsyncThunk(
  "Karigar/KarigarWiseGhatAmountPhineSummaryReport",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Karigar/KarigarWiseGhatAmountPhineSummaryReport`,
        formdata,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Karigar Amount Ledger Report:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getKarigarWiseBandhaiAmountPhineSummaryReport = createAsyncThunk(
  "Karigar/KarigarWiseBandhaiAmountPhineSummaryReport",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Karigar/KarigarWiseBandhaiAmountPhineSummaryReport`,
        formdata,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Karigar Amount Ledger Report:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getKarigarWisePalishAmountPhineSummaryReport = createAsyncThunk(
  "Karigar/KarigarWisePalishAmountLedgerReport",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Karigar/KarigarWisePalishAmountLedgerReport`,
        formdata,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Karigar Amount Ledger Report:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getKarigarWiseDullAmountLedgerReport = createAsyncThunk(
  "Karigar/KarigarWiseDullAmountLedgerReport",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Karigar/KarigarWiseDullAmountLedgerReport`,
        formdata,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Karigar Amount Ledger Report:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getKarigarWiseMinaAmountLedgerReport = createAsyncThunk(
  "Karigar/KarigarWiseMinaAmountLedgerReport",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Karigar/KarigarWiseMinaAmountLedgerReport`,
        formdata,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Karigar Amount Ledger Report:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getKarigarWiseJadaiAmountPhineSummaryReport = createAsyncThunk(
  "Karigar/KarigarWiseJadaiAmountPhineSummaryReport",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Karigar/KarigarWiseJadaiAmountPhineSummaryReport`,
        formdata,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Karigar Amount Ledger Report:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getStockReport = createAsyncThunk(
  "Item/ItemStockReport",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Item/ItemStockReport`,
        formdata,
      );
      return response.data?.Data;
    } catch (error: any) {
      console.error("Error Fetching Stock report:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
